import { useCallback, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useUser } from '@shared/hooks';
import { eventService } from 'library/api/eventService';
import { selectEvent, setSelectedEvent } from 'library/redux/events';
import { openNotifyModal } from 'library/redux/modal';
import { useAppDispatch, useAppSelector } from '../common';

const useEvent = () => {
  const dispatch = useAppDispatch();
  const event = useAppSelector(selectEvent);
  const { id } = useParams<{ id: string }>();
  const { user } = useUser();
  const navigate = useNavigate();

  const [status, setStatus] = useState<'idle' | 'loading' | 'loaded'>('idle');
  const isAuthor = user?.id === event?.author?.id;

  const showErrorModal = useCallback(() => {
    navigate(`/events`);
    dispatch(
      openNotifyModal({
        title: 'Мероприятие',
        text: 'Не удалось открыть мероприятие',
        confirmText: 'Ок',
      })
    );
  }, [dispatch, navigate]);

  const getEvent = useCallback(async () => {
    if (!id) return;

    setStatus('loading');
    try {
      const response = await eventService.getEvent(id);
      if (!response.data) throw new Error('Event not found');

      dispatch(setSelectedEvent(response.data));
      setStatus('loaded');
    } catch (error) {
      showErrorModal();
      setStatus('idle');
    }
  }, [id, dispatch, showErrorModal]);

  useEffect(() => {
    if (status === 'idle') {
      getEvent();
    }
  }, [getEvent, status]);

  return {
    event,
    status,
    isAuthor,
  };
};

export default useEvent;
